module.exports = __webpack_public_path__ + "img/prev-arrow-white.7f29e376.svg";